<template>
  <iframe
    class="native-map"
    :srcdoc="mapHtml"
    frameborder="0"
  />
</template>

<script lang="ts" setup>
  import { computed, onBeforeUnmount, onMounted } from 'vue';

  import iframeCss from '@/shared/ui/sights/native-yandex-map/iframe.css?raw';
  import iframeJsTemplate from '@/shared/ui/sights/native-yandex-map/iframe.txt?raw';
  import markerSvg from '@/shared/ui/sights/native-yandex-map/marker.svg?raw';

  const props = withDefaults(
    defineProps<{
      latitude: number;
      longitude: number;
      zoom?: number;
      behaviors?: string[];
    }>(),
    {
      zoom: 15,
      behaviors: () => ['pinchZoom', 'dblClick'],
    },
  );

  const emit = defineEmits<{
    (e: 'map-action', action: string): void;
  }>();

  const onMessage = (event: MessageEvent) => {
    const { data } = event;

    if (data && data.source === 'native-yandex-map' && data.payload?.actionType) {
      emit('map-action', String(data.payload.actionType));
    }
  };

  onMounted(() => {
    window.addEventListener('message', onMessage);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('message', onMessage);
  });
  const API_KEY = import.meta.env.VITE_YANDEX_MAP_KEY || '05f23d6d-b09f-48e8-824f-67143f7e0de6';

  const apiUrl = `https://api-maps.yandex.ru/v3/?apikey=${API_KEY}&lang=ru_RU`;

  const mapHtml = computed(() => {
    const script = iframeJsTemplate
      .replace('__COORDS__', JSON.stringify([props.longitude, props.latitude]))
      .replace('__ZOOM__', String(props.zoom))
      .replace('__BEHAVIORS__', JSON.stringify(props.behaviors))
      .replace('__MARKER_SVG__', markerSvg.replace(/\n\s*/g, ''));

    const scriptTag = 'script';
    const scriptOpen = `<${scriptTag}>`;
    const scriptClose = `</${scriptTag}>`;
    const scriptSrc = `<${scriptTag} src="${apiUrl}">${scriptClose}`;

    return `<!DOCTYPE html>
  <html>
  <head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <style>${iframeCss}</style>
  ${scriptSrc}
  </head>
  <body>
  <div id="map"></div>
  ${scriptOpen}${script}${scriptClose}
  </body>
  </html>`;
  });
</script>

<style lang="scss" scoped>
  .native-map {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
</style>
